var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.url)?[_vm._v("\n    "+_vm._s(this.item)+"\n  ")]:[_c('router-link',{staticClass:"border-b border-transparent hover:border-orange-brand",attrs:{"to":_vm.url}},[_vm._v("\n      "+_vm._s(_vm.item.title)+"\n    ")])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }